import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NavbarComponent } from 'angular-bootstrap-md';
import { UsuarioFinalComponent } from '../../@pages/usuario-final/usuario-final.component';

const routes: Routes = [
    {
        path: '',
        component: NavbarComponent,
    },
    {
        path: 'oefa',
        component: UsuarioFinalComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class NavbarComponentRouting { }
